import {PanelInteractContextProvider} from '@wandb/weave/components/Panel2/PanelInteractContext';
import {PanelRootContextProvider as WeavePanelRootContextProvider} from '@wandb/weave/components/Panel2/PanelPanel';
import {PanelRenderedConfigContextProvider} from '@wandb/weave/components/Panel2/PanelRenderedConfigContext';
import React from 'react';

const PanelRootContextProvider = WeavePanelRootContextProvider as React.FC<{
  children?: React.ReactNode;
}>;

export const Weave1PanelContextProvider = React.memo(
  ({children}: {children?: React.ReactNode}) => {
    return (
      <PanelRootContextProvider>
        <PanelRenderedConfigContextProvider>
          <PanelInteractContextProvider>
            {children}
          </PanelInteractContextProvider>
        </PanelRenderedConfigContextProvider>
      </PanelRootContextProvider>
    );
  }
);
Weave1PanelContextProvider.displayName = 'Weave1PanelContextProvider';
